(function(){
  'use strict';
  /* Owner-tools loader — inert for visitors. Activates via ?theme_diag=1 (remembered in this browser),
     inside the theme editor preview, or until dismissed via the tools panel / ?theme_diag=0 */
  /* ---- Owner tools access control ----
     Unlock sessions expire (12h hard / 60min idle). With a password set there is NO passwordless path.
     Tools are read-only diagnostics over public storefront data — they cannot modify the store. */
  var _cs=document.currentScript;
  var ownerKey=_cs&&_cs.getAttribute('data-owner-key');
  var OG_HARD_MS=43200000, OG_IDLE_MS=3600000;
  function ogToken(){
    try{
      var t=JSON.parse(localStorage.getItem('og_tools'));
      var now=Date.now();
      if(t&&t.exp&&t.act&&now<t.exp&&(now-t.act)<OG_IDLE_MS){
        t.act=now; localStorage.setItem('og_tools',JSON.stringify(t)); return true;
      }
    }catch(e){}
    try{ localStorage.removeItem('og_tools'); }catch(e){}
    return false;
  }
  function ogUnlock(){ try{ localStorage.setItem('og_tools',JSON.stringify({exp:Date.now()+OG_HARD_MS,act:Date.now()})); }catch(e){} }
  var loadDiag=function(){ var s=_cs&&_cs.getAttribute('data-diag'); if(s&&!document.querySelector('script[src*="diag.js"]')){ var t=document.createElement('script'); t.src=s; document.head.appendChild(t); } };
  var wantsOn=location.search.indexOf('theme_diag=1')>-1;
  var wantsOff=location.search.indexOf('theme_diag=0')>-1;
  if(wantsOff){ try{ localStorage.removeItem('og_tools'); }catch(e){} }
  var unlocked=!wantsOff&&(ogToken()||(window.Shopify&&window.Shopify.designMode));
  if(!unlocked&&wantsOn&&!ownerKey){ ogUnlock(); unlocked=true; } /* no password configured: URL bootstrap (set one!) */
  if(unlocked) loadDiag();

  function ogPwBox(dot){
    if(document.getElementById('og-pw-box')) return;
    var now=Date.now(), lock=0;
    try{ lock=+localStorage.getItem('og_pw_lock')||0; }catch(e){}
    var box=document.createElement('form');
    box.id='og-pw-box';
    box.style.cssText='position:fixed;bottom:20px;left:8px;z-index:10000;background:#141414;border:1px solid #b8953a;border-radius:4px;padding:8px;display:flex;gap:6px';
    var inp=document.createElement('input');
    inp.type='password'; inp.placeholder='Owner password'; inp.autocomplete='off';
    inp.style.cssText='background:#0d0d0d;border:1px solid #444;color:#eee;padding:6px 8px;font-size:13px;width:150px';
    var go=document.createElement('button');
    go.type='submit'; go.textContent='Unlock';
    go.style.cssText='background:#b8953a;color:#0d0d0d;border:none;padding:6px 10px;font-weight:700;cursor:pointer;font-size:12px';
    box.appendChild(inp); box.appendChild(go); document.body.appendChild(box);
    if(now<lock){ inp.disabled=true; go.disabled=true; inp.placeholder='Locked — try later'; setTimeout(function(){ box.remove(); },2500); return; }
    inp.focus();
    box.addEventListener('submit',function(e){
      e.preventDefault();
      var shop=(window.Shopify&&Shopify.shop)||'';
      crypto.subtle.digest('SHA-256',new TextEncoder().encode(shop+':'+inp.value)).then(function(buf){
        var hex=Array.prototype.map.call(new Uint8Array(buf),function(b){return ('0'+b.toString(16)).slice(-2);}).join('');
        if(hex===ownerKey){
          try{ localStorage.removeItem('og_pw_n'); localStorage.removeItem('og_pw_lock'); }catch(err){}
          ogUnlock(); box.remove(); if(dot) dot.remove(); loadDiag();
        } else {
          var n=0; try{ n=(+localStorage.getItem('og_pw_n')||0)+1; localStorage.setItem('og_pw_n',n); }catch(err){}
          if(n>=5){ try{ localStorage.setItem('og_pw_lock',Date.now()+300000); localStorage.removeItem('og_pw_n'); }catch(err){} inp.disabled=true; go.disabled=true; inp.value=''; inp.placeholder='Locked for 5 minutes'; setTimeout(function(){ box.remove(); },2500); return; }
          inp.value=''; inp.placeholder='Wrong password';
          setTimeout(function(){ inp.placeholder='Owner password'; },1500);
        }
      });
    });
    document.addEventListener('keydown',function esc(e){ if(e.key==='Escape'){ box.remove(); document.removeEventListener('keydown',esc); } });
  }

  if(ownerKey&&!unlocked&&window.crypto&&crypto.subtle){
    document.addEventListener('DOMContentLoaded',function(){
      if(wantsOn){ ogPwBox(null); } /* URL summons the password box only — never an unlock */
      /* Invisible corner trigger: triple-click within 2s in the bottom-left corner zone.
         No visual, no hover reveal, not in tab order. 36px zone so a real human triple-click lands. */
      var dot=document.createElement('button');
      dot.setAttribute('aria-hidden','true'); dot.tabIndex=-1;
      dot.style.cssText='position:fixed;bottom:0;left:0;width:36px;height:36px;z-index:9999;background:none;border:none;cursor:default;color:transparent;padding:0;-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent';
      var clicks=[];
      dot.addEventListener('click',function(){
        var now=Date.now(); clicks.push(now);
        clicks=clicks.filter(function(t){ return now-t<2000; });
        if(clicks.length>=3){ clicks=[]; ogPwBox(dot); }
      });
      document.body.appendChild(dot);
    });
  }
  var $ = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var money = function(cents){return '$'+(cents/100).toFixed(2);};
  var esc = function(t){var d=document.createElement('div');d.textContent=t==null?'':t;return d.innerHTML;};
  var dl = function(obj){ if(window.dataLayer) { window.dataLayer.push({ecommerce:null}); window.dataLayer.push(obj); } };
  var showMsg = function(el,msg){ if(!el) return; el.textContent=msg; el.classList.remove('hidden'); clearTimeout(el._t); el._t=setTimeout(function(){el.classList.add('hidden');},6000); };

  /* Mobile nav */
  var navToggle = $('[data-nav-toggle]'), menu = $('.menu');
  if(navToggle && menu){ navToggle.addEventListener('click',function(){
    var open = menu.classList.toggle('open');
    navToggle.setAttribute('aria-expanded', open?'true':'false');
  });}

  var TS=window.themeStrings||{};

  /* Search panel + predictive */
  var searchToggle = $('[data-search-toggle]'), searchPanel = $('[data-search-panel]');
  if(searchToggle && searchPanel){ searchToggle.addEventListener('click',function(){
    searchPanel.hidden = !searchPanel.hidden;
    searchToggle.setAttribute('aria-expanded', searchPanel.hidden?'false':'true');
    if(!searchPanel.hidden){ var i=$('[data-predictive]'); if(i) i.focus(); }
  });}
  var pInput = $('[data-predictive]'), pResults = $('[data-predictive-results]'), pTimer;
  if(pInput){ pInput.addEventListener('input',function(){
    clearTimeout(pTimer); var q=pInput.value.trim();
    if(q.length<2){ pResults.innerHTML=''; return; }
    pTimer=setTimeout(function(){
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function(r){return r.json();})
        .then(function(d){
          var res=(d.resources&&d.resources.results)||{};
          var prods=res.products||[], colls=res.collections||[], pages=res.pages||[];
          var out='';
          if(prods.length){
            out+='<div class="pv-group">'+(TS.products||'Products')+'</div>'+prods.map(function(p){
              var u=p.featured_image&&p.featured_image.url;
              var img=u?'<img src="'+u+(u.indexOf('?')>-1?'&':'?')+'width=80" width="40" height="40" alt="" loading="lazy">':'';
              var price=p.price?'<span class="pv-p">$'+p.price+'</span>':'';
              return '<a class="pv-item" href="'+p.url+'">'+img+'<span>'+esc(p.title)+'</span>'+price+'</a>';
            }).join('');
          }
          if(colls.length){
            out+='<div class="pv-group">'+(TS.collections||'Collections')+'</div>'+colls.map(function(c){
              return '<a class="pv-item" href="'+c.url+'"><span>'+esc(c.title)+'</span></a>';
            }).join('');
          }
          if(pages.length){
            out+='<div class="pv-group">'+(TS.pages||'Pages')+'</div>'+pages.map(function(pg){
              return '<a class="pv-item" href="'+pg.url+'"><span>'+esc(pg.title)+'</span></a>';
            }).join('');
          }
          if(out){ out+='<a class="pv-all" href="/search?q='+encodeURIComponent(q)+'">'+(TS.seeAll||'See all results for “{{ terms }}” →').replace('{{ terms }}',esc(q))+'</a>'; }
          pResults.innerHTML=out || '<p class="muted">'+(TS.noMatches||'No matches')+'</p>';
        }).catch(function(){});
    },200);
  });}

  /* Slideshow arrows */
  $$('[data-slider]').forEach(function(sl){
    var slides=$('[data-slides]',sl); if(!slides) return;
    var prev=$('[data-prev]',sl), next=$('[data-next]',sl);
    var step=function(){return slides.clientWidth;};
    if(prev) prev.addEventListener('click',function(){slides.scrollBy({left:-step(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){slides.scrollBy({left:step(),behavior:'smooth'});});
  });

  /* Scroll reveal */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in-view'); io.unobserve(e.target);} });
    },{threshold:.12});
    $$('.reveal').forEach(function(el){io.observe(el);});
  } else { $$('.reveal').forEach(function(el){el.classList.add('in-view');}); }

  /* PDP image gallery + variants */
  var pdpMain=$('#pdpMain');
  var pdpThumbs=$$('.pdp-thumb');
  /* KEY FIX: the main <img> has a srcset of the ORIGINAL image, which overrides any src we set — so the picture
     never actually changed. Clear srcset/sizes whenever we swap the main image. */
  function setMainImage(url){ if(!pdpMain||!url) return; pdpMain.removeAttribute('srcset'); pdpMain.removeAttribute('sizes'); pdpMain.src=url; }
  pdpThumbs.forEach(function(t){ t.addEventListener('click',function(){ setMainImage(t.getAttribute('data-src')); }); });
  /* POD products carry front/back(/tag) images per color (alt = "COLOR - MODEL - VIEW"). Replace the 100-thumbnail
     wall with two clickable images — Front and Back — for the chosen color (the tag view is skipped). */
  function thumbColor(t){ var a=t.getAttribute('data-alt')||''; var p=a.split(' - '); return p.length>1?p[0].trim().toLowerCase():null; }
  function thumbView(t){ var a=t.getAttribute('data-alt')||''; var p=a.split(' - '); return p.length?p[p.length-1].trim().toUpperCase():''; }
  function thumbSmall(t){ var im=t.querySelector('img'); return (im&&im.getAttribute('src'))||t.getAttribute('data-src'); }
  var pdpHasColorThumbs=pdpThumbs.some(function(t){ return thumbColor(t)!==null; });
  var VIEW_LABEL={FRONT:'Front',BACK:'Back',SIDE:'Side',LEFT:'Left',RIGHT:'Right'};
  var VIEW_ORDER={FRONT:0,BACK:1,LEFT:2,RIGHT:3,SIDE:4};
  var SKIP_VIEWS={INSIDE_TAG_LINE:1,TAG:1};
  var viewGalleryEl=null, curViews=[], curIdx=0;
  function markActive(idx){ if(!viewGalleryEl) return; Array.prototype.forEach.call(viewGalleryEl.children,function(x,i){ x.classList.toggle('is-active', i===idx); }); curIdx=idx; }
  function showView(idx){ if(!curViews.length) return; idx=(idx+curViews.length)%curViews.length; setMainImage(curViews[idx].getAttribute('data-src')); markActive(idx); }
  function buildViewGallery(color){
    if(!pdpHasColorThumbs) return;
    if(!viewGalleryEl){
      var strip=$('.pdp-thumbs'); if(strip) strip.style.display='none';
      viewGalleryEl=document.createElement('div'); viewGalleryEl.className='pdp-views';
      var mainWrap=$('.pdp-main');
      if(mainWrap&&mainWrap.parentNode) mainWrap.parentNode.insertBefore(viewGalleryEl, mainWrap.nextSibling);
      else if(pdpMain&&pdpMain.parentNode) pdpMain.parentNode.appendChild(viewGalleryEl);
      /* clicking the big image opens the full-screen viewer */
      if(pdpMain){ pdpMain.style.cursor='zoom-in'; pdpMain.addEventListener('click',openLightbox); }
    }
    color=String(color||'').trim().toLowerCase();
    var matches=pdpThumbs.filter(function(t){ return thumbColor(t)===color && !SKIP_VIEWS[thumbView(t)]; });
    if(!matches.length) matches=pdpThumbs.filter(function(t){ return !SKIP_VIEWS[thumbView(t)]; }).slice(0,2);
    matches.sort(function(a,b){ return (VIEW_ORDER[thumbView(a)]===undefined?5:VIEW_ORDER[thumbView(a)])-(VIEW_ORDER[thumbView(b)]===undefined?5:VIEW_ORDER[thumbView(b)]); });
    curViews=matches; curIdx=0;
    viewGalleryEl.innerHTML='';
    matches.forEach(function(t,i){
      var v=thumbView(t), label=VIEW_LABEL[v]||(v.charAt(0)+v.slice(1).toLowerCase());
      var b=document.createElement('button'); b.type='button'; b.className='pdp-view-thumb'+(i===0?' is-active':'');
      var im=document.createElement('img'); im.src=thumbSmall(t); im.alt=label; im.loading='lazy';
      var cap=document.createElement('span'); cap.textContent=label;
      b.appendChild(im); b.appendChild(cap);
      b.addEventListener('click',function(){ showView(i); });
      viewGalleryEl.appendChild(b);
    });
    if(matches[0]) setMainImage(matches[0].getAttribute('data-src'));  /* main image -> this color's front */
  }
  /* FULL-SCREEN IMAGE VIEWER — click the product photo to see it big; switch Front/Back; close with X, backdrop, or Esc. */
  var lbEl=null,lbImg=null,lbNav=null,lbIdx=0;
  function bigUrl(t){ var u=t.getAttribute('data-src')||''; return /[?&]width=\d+/.test(u)? u.replace(/([?&]width=)\d+/,'$$11600') : (u+(u.indexOf('?')>-1?'&':'?')+'width=1600'); }
  function renderLbNav(idx){ if(!lbNav) return; lbNav.innerHTML=''; if(curViews.length<2) return;
    curViews.forEach(function(t,i){ var v=thumbView(t), label=VIEW_LABEL[v]||(v.charAt(0)+v.slice(1).toLowerCase());
      var b=document.createElement('button'); b.type='button'; b.className='pdp-lb-btn'+(i===idx?' is-active':''); b.textContent=label;
      b.addEventListener('click',function(e){ e.stopPropagation(); lbShow(i); }); lbNav.appendChild(b); }); }
  function lbShow(idx){ if(!curViews.length) return; idx=(idx+curViews.length)%curViews.length; lbIdx=idx; if(lbImg) lbImg.src=bigUrl(curViews[idx]); renderLbNav(idx); }
  function buildLightbox(){
    lbEl=document.createElement('div'); lbEl.className='pdp-lightbox'; lbEl.hidden=true;
    lbEl.innerHTML='<button class="pdp-lb-close" type="button" aria-label="Close">\u2715</button><div class="pdp-lb-stage"><img alt="" class="pdp-lb-img"></div><div class="pdp-lb-nav"></div>';
    document.body.appendChild(lbEl);
    lbImg=lbEl.querySelector('.pdp-lb-img'); lbNav=lbEl.querySelector('.pdp-lb-nav');
    lbEl.addEventListener('click',function(e){ if(e.target===lbEl||e.target.classList.contains('pdp-lb-stage')||e.target.classList.contains('pdp-lb-close')) closeLightbox(); });
    lbImg.addEventListener('click',function(e){ e.stopPropagation(); if(curViews.length>1) lbShow(lbIdx+1); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&lbEl&&!lbEl.hidden) closeLightbox(); });
  }
  function openLightbox(){ if(!curViews.length) return; if(!lbEl) buildLightbox(); lbShow(curIdx); lbEl.hidden=false; document.body.style.overflow='hidden'; }
  function closeLightbox(){ if(lbEl){ lbEl.hidden=true; document.body.style.overflow=''; } }
  var pdpForm=$('[data-product-form]');
  var qty=$('[data-qty]');
  if(qty){ var m=$('[data-qty-minus]'),p=$('[data-qty-plus]');
    if(m)m.addEventListener('click',function(){qty.value=Math.max(1,(+qty.value||1)-1);});
    if(p)p.addEventListener('click',function(){var nv=(+qty.value||1)+1; var mx=+qty.max||Infinity; qty.value=Math.min(nv,mx);});
  }

  /* Variant selection sync */
  var pjson=$('[data-product-json]');
  if(pdpForm && pjson){
    var PRODUCT=null;
    try{ PRODUCT=JSON.parse(pjson.textContent); }catch(err){}
    if(PRODUCT && PRODUCT.variants && PRODUCT.variants.length>1){
      var vSelects=$$('.pdp-variant[data-option-index]');
      var colorIdx=0; if(PRODUCT.options){ for(var oi=0;oi<PRODUCT.options.length;oi++){ var on=PRODUCT.options[oi]; on=(on&&on.name)||on; if(String(on).toLowerCase()==='color'){ colorIdx=oi; break; } } }
      var priceEl=document.getElementById('pdpPrice');
      var idEl=$('[data-variant-id]',pdpForm);
      var addBtn=$('[data-add]',pdpForm);
      var findVariant=function(){
        var sel=vSelects.map(function(s){return s.value;});
        for(var i=0;i<PRODUCT.variants.length;i++){
          var v=PRODUCT.variants[i], vo=[v.option1,v.option2,v.option3], ok=true;
          for(var j=0;j<sel.length;j++){ if(vo[j]!==sel[j]){ ok=false; break; } }
          if(ok) return v;
        }
        return null;
      };
      var syncVariant=function(){
        var v=findVariant();
        if(!v){ if(addBtn){addBtn.disabled=true;addBtn.textContent=(TS.unavailable||'Unavailable');} return; }
        if(idEl) idEl.value=v.id;
        if(addBtn){ addBtn.disabled=!v.available; addBtn.textContent=v.available?(TS.addToCart||'Add to Cart'):(TS.soldOut||'Sold Out'); }
        if(priceEl){ priceEl.innerHTML=(v.compare_at_price&&v.compare_at_price>v.price)?'<span class="sale-price">'+money(v.price)+'</span> <s class="was">'+money(v.compare_at_price)+'</s>':money(v.price); }
        if(v.featured_image&&v.featured_image.src&&pdpMain){ setMainImage(v.featured_image.src); }
        buildViewGallery(v['option'+(colorIdx+1)]);
        var note=$('[data-stock-note]'); var invEl=$('[data-inventory-json]');
        if(note&&invEl){ try{
          var inv=JSON.parse(invEl.textContent); var q=inv[String(v.id)]; var th=+note.getAttribute('data-threshold')||5;
          if(q!==null&&q!==undefined&&q>0&&q<=th){ note.textContent=(TS.onlyLeft||'★ Only {{ count }} left in stock').replace('{{ count }}',q); note.classList.remove('hidden'); }
          else{ note.classList.add('hidden'); }
        }catch(err){} }
        var bis=$('[data-bis]'); if(bis){ bis.classList.toggle('hidden', !!v.available); }
        var sp=$('[data-sticky-price]'); if(sp){ sp.textContent=money(v.price); }
        if(qty&&invEl){ try{ var iq=JSON.parse(invEl.textContent)[String(v.id)];
          if(iq!==null&&iq!==undefined&&iq>0){ qty.max=iq; if(+qty.value>iq) qty.value=iq; } else { qty.removeAttribute('max'); }
        }catch(err){} }
        var sb=$('[data-sticky-add]'); if(sb){ sb.disabled=!v.available; sb.textContent=v.available?(TS.addToCart||'Add to Cart'):(TS.soldOut||'Sold Out'); }
        try{ var u=new URL(window.location.href); u.searchParams.set('variant',v.id); history.replaceState({},'',u); }catch(err){}
      };
      vSelects.forEach(function(s){ s.addEventListener('change',syncVariant); });
      var initColorSel=$('.pdp-variant[data-option-index="'+colorIdx+'"]');
      buildViewGallery(initColorSel?initColorSel.value:null);
    }
  }

  /* Cart drawer */
  var drawer=$('[data-cart-drawer]');
  function openDrawer(){ if(!drawer)return; drawer.hidden=false; drawer.setAttribute('aria-hidden','false'); var go=function(){ drawer.classList.add('open'); var c=$('button[data-cart-close]',drawer); if(c) c.focus(); }; requestAnimationFrame(go); setTimeout(go,60); }
  function closeDrawer(){ if(!drawer)return; drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); setTimeout(function(){drawer.hidden=true;},300); }
  $$('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeDrawer);});
  var cartToggle=$('[data-cart-toggle]');
  if(cartToggle && drawer){ cartToggle.addEventListener('click',function(e){ e.preventDefault(); renderCart(); openDrawer(); }); }

  function renderCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var wrap=$('[data-cart-items]'); if(wrap){
        wrap.innerHTML = cart.items.length? cart.items.map(function(it,i){
          var img = it.image ? '<img class="cart-thumb" src="'+it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=120" width="56" height="56" alt="" loading="lazy">' : '';
          var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cart-line-var">'+esc(it.variant_title)+'</div>' : '';
          return '<div class="cart-row" data-line="'+(i+1)+'">'+img
            +'<div class="cart-line"><div class="cart-line-title">'+esc(it.product_title)+'</div>'+vt
            +'<div class="cart-line-qty"><button type="button" class="qty-mini" data-line-minus aria-label="'+(TS.decrease||'Decrease')+'">−</button><span>'+it.quantity+'</span><button type="button" class="qty-mini" data-line-plus aria-label="'+(TS.increase||'Increase')+'">+</button><button type="button" class="line-remove" data-line-remove aria-label="'+(TS.removeItem||'Remove item')+'">✕</button></div></div>'
            +'<span class="cart-line-price">'+money(it.final_line_price)+'</span></div>';
        }).join('') : '<p class="muted">'+(TS.emptyCart||'Your cart is empty.')+'</p>';
      }
      var sub=$('[data-cart-subtotal]'); if(sub) sub.textContent=(TS.subtotal||'Subtotal')+': '+money(cart.total_price);
      $$('[data-cart-count]').forEach(function(c){c.textContent=cart.item_count;});
      var bar=$('[data-ship-bar]');
      if(bar){ var th=+bar.getAttribute('data-threshold')||0; var fill=$('.ship-fill',bar),txt=$('.ship-text',bar);
        var pct=th?Math.min(100,cart.total_price/th*100):100;
        if(fill)fill.style.width=pct+'%';
        if(txt)txt.textContent = cart.total_price>=th ? (TS.freeShipUnlocked||'You unlocked free shipping ★') : (TS.freeShipAway||'{{ amount }} away from free shipping').replace('{{ amount }}',money(th-cart.total_price));
      }
    });
  }

  if(pdpForm){
    pdpForm.addEventListener('submit',function(e){
      e.preventDefault();
      var id=($('[data-variant-id]',pdpForm)||{}).value;
      var q=(qty&&qty.value)||1;
      var btn=$('[data-add]',pdpForm); if(btn){btn.disabled=true;btn.textContent=(TS.adding||'Adding…');}
      var errEl=$('[data-form-error]',pdpForm.parentNode)||$('[data-form-error]');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:+q})})
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
        .then(function(res){
          if(!res.ok){ showMsg(errEl, res.d.description||res.d.message||(TS.unableToAdd||'Unable to add to cart.')); return; }
          dl({event:'add_to_cart',ecommerce:{currency:'USD',value:(res.d.price||0)/100*(+q),items:[{item_id:res.d.sku||res.d.variant_id,item_name:res.d.product_title,price:(res.d.price||0)/100,quantity:+q}]}});
          renderCart(); openDrawer();
        })
        .catch(function(){ showMsg(errEl,(TS.networkError||'Network error — please try again.')); })
        .finally(function(){ if(btn){btn.disabled=false;btn.textContent=(TS.addToCart||'Add to Cart');} });
    });
  }

  /* Cart line quantity / remove */
  if(drawer){
    drawer.addEventListener('click',function(e){
      var row=e.target.closest('[data-line]'); if(!row) return;
      var q=null, qEl=row.querySelector('.cart-line-qty span'), cur=qEl?(+qEl.textContent||1):1;
      if(e.target.closest('[data-line-minus]')) q=cur-1;
      else if(e.target.closest('[data-line-plus]')) q=cur+1;
      else if(e.target.closest('[data-line-remove]')) q=0;
      if(q===null) return;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+row.getAttribute('data-line'),quantity:Math.max(0,q)})})
        .then(function(r){return r.json();}).then(function(){ renderCart(); }).catch(function(){});
    });
  }

  /* Escape closes overlays, returns focus */
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape') return;
    if(drawer && !drawer.hidden){ closeDrawer(); if(cartToggle) cartToggle.focus(); }
    else if(searchPanel && !searchPanel.hidden){ searchPanel.hidden=true; if(searchToggle){ searchToggle.setAttribute('aria-expanded','false'); searchToggle.focus(); } }
  });

  /* Quick add from product cards */
  $$('[data-quick-add]').forEach(function(b){
    b.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var vid=b.getAttribute('data-variant-id'); if(!vid) return;
      b.disabled=true; var t=b.textContent; b.textContent=(TS.adding||'Adding…');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:+vid,quantity:1})})
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
        .then(function(res){
          if(!res.ok){ renderCart(); openDrawer(); showMsg($('[data-cart-error]'), res.d.description||res.d.message||(TS.unableToAdd||'Unable to add.')); return; }
          dl({event:'add_to_cart',ecommerce:{currency:'USD',value:(res.d.price||0)/100,items:[{item_id:res.d.sku||res.d.variant_id,item_name:res.d.product_title,price:(res.d.price||0)/100,quantity:1}]}});
          renderCart(); openDrawer();
        })
        .catch(function(){})
        .finally(function(){ b.disabled=false; b.textContent=t; });
    });
  });

  /* Quick view modal */
  var qv=$('[data-qv]');
  if(qv){
    var qvProduct=null, qvVariant=null;
    var qvClose=function(){ qv.hidden=true; };
    $$('[data-qv-close]',qv).forEach(function(b){b.addEventListener('click',qvClose);});
    qv.addEventListener('click',function(e){ if(e.target===qv) qvClose(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!qv.hidden) qvClose(); });
    var qvSync=function(){
      var sels=$$('[data-qv-opt]',qv).map(function(s){return s.value;});
      qvVariant=null;
      if(qvProduct){
        if(!sels.length){ qvVariant=qvProduct.variants[0]; }
        else{
          for(var i=0;i<qvProduct.variants.length;i++){
            var v=qvProduct.variants[i], ok=true;
            for(var j=0;j<sels.length;j++){ if((v.options[j]||null)!==sels[j]){ ok=false; break; } }
            if(ok){ qvVariant=v; break; }
          }
        }
      }
      var add=$('[data-qv-add]',qv);
      if(!qvVariant){ if(add){add.disabled=true;add.textContent=(TS.unavailable||'Unavailable');} return; }
      if(add){ add.disabled=!qvVariant.available; add.textContent=qvVariant.available?(TS.addToCart||'Add to Cart'):(TS.soldOut||'Sold Out'); }
      $('[data-qv-price]',qv).innerHTML=(qvVariant.compare_at_price&&qvVariant.compare_at_price>qvVariant.price)?'<span class="sale-price">'+money(qvVariant.price)+'</span> <s class="was">'+money(qvVariant.compare_at_price)+'</s>':money(qvVariant.price);
      if(qvVariant.featured_image&&qvVariant.featured_image.src){ var im=$('[data-qv-img]',qv); im.src=qvVariant.featured_image.src; im.hidden=false; }
    };
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-quick-view]'); if(!b) return;
      e.preventDefault(); e.stopPropagation();
      fetch('/products/'+b.getAttribute('data-handle')+'.js').then(function(r){return r.json();}).then(function(p){
        qvProduct=p;
        $('[data-qv-title]',qv).textContent=p.title;
        var im=$('[data-qv-img]',qv);
        if(p.featured_image){ im.src=p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=600'; im.hidden=false; }
        else{ im.hidden=true; }
        $('[data-qv-link]',qv).href=p.url;
        var opts=$('[data-qv-options]',qv); opts.innerHTML='';
        var hasVariants=!(p.variants.length===1&&p.variants[0].title==='Default Title');
        if(hasVariants){
          p.options.forEach(function(o,idx){
            var name=(o&&o.name)||o;
            var values=(o&&o.values)||p.variants.map(function(v){return v.options[idx];}).filter(function(v,i,a){return a.indexOf(v)===i;});
            var lbl=document.createElement('label'); lbl.className='opt-label'; lbl.textContent=name; opts.appendChild(lbl);
            var sel=document.createElement('select'); sel.className='pdp-variant'; sel.setAttribute('data-qv-opt',idx);
            values.forEach(function(v){ var op=document.createElement('option'); op.value=v; op.textContent=v; sel.appendChild(op); });
            sel.addEventListener('change',qvSync); opts.appendChild(sel);
          });
        }
        qvSync(); qv.hidden=false;
        var c=$('[data-qv-close]',qv); if(c) c.focus();
      }).catch(function(){});
    });
    var qvAdd=$('[data-qv-add]',qv);
    if(qvAdd) qvAdd.addEventListener('click',function(){
      if(!qvVariant) return;
      qvAdd.disabled=true; qvAdd.textContent=(TS.adding||'Adding…');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:qvVariant.id,quantity:1})})
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
        .then(function(res){
          if(!res.ok){ showMsg($('[data-qv-error]',qv), res.d.description||res.d.message||(TS.unableToAdd||'Unable to add.')); return; }
          dl({event:'add_to_cart',ecommerce:{currency:'USD',value:(res.d.price||0)/100,items:[{item_id:res.d.sku||res.d.variant_id,item_name:res.d.product_title,price:(res.d.price||0)/100,quantity:1}]}});
          qvClose(); renderCart(); openDrawer();
        })
        .catch(function(){ showMsg($('[data-qv-error]',qv),(TS.networkError||'Network error — please try again.')); })
        .finally(function(){ qvAdd.disabled=false; if(qvVariant&&qvVariant.available) qvAdd.textContent=(TS.addToCart||'Add to Cart'); });
    });
  }

  /* Sticky mobile add-to-cart (scroll-position based — works everywhere) */
  var stickyBar=$('[data-sticky-atc]');
  if(stickyBar && pdpForm){
    var mainAdd=$('[data-add]',pdpForm);
    if(mainAdd){
      var stickySync=function(){
        stickyBar.hidden = mainAdd.getBoundingClientRect().bottom > 0;
      };
      window.addEventListener('scroll',stickySync,{passive:true});
      window.addEventListener('resize',stickySync,{passive:true});
      stickySync();
      var sBtn=$('[data-sticky-add]');
      if(sBtn) sBtn.addEventListener('click',function(){ if(mainAdd&&!mainAdd.disabled) mainAdd.click(); });
    }
  }

  /* begin_checkout analytics */
  $$('[data-checkout]').forEach(function(c){ c.addEventListener('click',function(){ dl({event:'begin_checkout'}); }); });

  /* Collection facets: auto-submit */
  var facets=$('[data-facets]');
  if(facets){
    var go=function(){
      var params=new URLSearchParams();
      $$('[data-facet-input]',facets).forEach(function(i){ if(i.checked) params.append(i.name,i.value); });
      var sort=$('[data-sort]',facets); if(sort&&sort.value) params.set('sort_by',sort.value);
      window.location.search=params.toString();
    };
    $$('[data-facet-input]',facets).forEach(function(i){i.addEventListener('change',go);});
    var sort=$('[data-sort]',facets); if(sort) sort.addEventListener('change',go);
  }

  /* Marquee: fill full width + seamless clone.
     Deferred past first paint; measures layout once and appends in a single
     batch (the old read-clone-read loop forced dozens of synchronous layouts
     before first paint — it was the page's biggest FCP delay). */
  $$('[data-marquee]').forEach(function(m){
    var track=$('[data-marquee-track]',m), group=$('[data-marquee-group]',m);
    if(!track||!group||!group.children.length) return;
    setTimeout(function(){
      var w=group.scrollWidth, target=m.clientWidth*1.2;
      if(w>0 && w<target){
        var orig=Array.prototype.slice.call(group.children);
        var copies=Math.min(60, Math.ceil(target/w)-1);
        var frag=document.createDocumentFragment();
        for(var i=0;i<copies;i++){ orig.forEach(function(c){frag.appendChild(c.cloneNode(true));}); }
        group.appendChild(frag);
      }
      var clone=group.cloneNode(true); clone.setAttribute('aria-hidden','true'); track.appendChild(clone);
    }, 0);
  });

  /* Update cart count on load */
  $$('[data-cart-count]').forEach(function(){ /* server-rendered; refresh silently */ });
})();
